import { useTheme } from '@mui/material';

export const TryAgainIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke, tertiary: tertiaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <circle cx={21.084} cy={22.145} r={14.417} fill={primaryBackground} opacity={0.1} />
            <path
                stroke={tertiaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M5.14 19.495a14.096 14.096 0 0 1 26.308-7.049"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M22.761 12.447h8.81v-8.81"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M33.333 19.495a14.096 14.096 0 0 1-26.307 7.048"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15.713 26.543h-8.81v8.81"
            />
        </svg>
    );
};
